import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Col, Row,
} from 'react-bootstrap';
import Table from 'components/Table';
import TextField from 'components/Form/TextField';
import { CellProps } from 'react-table';
import { DTable } from 'types/table';
import { IoIosAddCircleOutline } from 'react-icons/io';
import _ from 'lodash';
import moment from 'moment';
import { copyClipboard, getNdaStatusName } from 'utils/utils';
import { AiOutlineDelete } from 'react-icons/ai';
import DeleteInvitationModal from 'components/Modal/DeleteInvitationModal';
import { Invitation } from 'types/Invitation';
import { FaRegCheckCircle, FaRegClone, FaRegCopy } from 'react-icons/fa';

function Invitations( {
  invitations, fetchData, isLoading, openCreateInvitationModal, openEditInvitationModal,
  reloadData, openCloneInvitationModal,
}:{
  openCreateInvitationModal: ( )=>void
  openEditInvitationModal: ( dataInvitation:any )=>void
  isLoading?:boolean;
  invitations:DTable;
  fetchData: ( params:any, pageSize:number )=>void ;
  reloadData: () => void,
  openCloneInvitationModal: ( dataInvitation: any ) => void;
} ) {
  const { t } = useTranslation();
  const [criteria, setCriteria] = useState( '' );
  const [showDeleteModal, setDeleteModal] = useState( false );
  const selectedInvitationRef = useRef<Invitation>();
  const [copiedId, setCopiedId] = useState<string | null>( null );

  const debounceSearch = useCallback( _.debounce( ( fn ) => fn(), 500 ), [] );

  const closeDeleteModal = useCallback( ( ) => {
    setDeleteModal( false );
    selectedInvitationRef.current = undefined;
  }, [] );

  const openDeleteModal = useCallback( ( inv?: Invitation ) => {
    selectedInvitationRef.current = inv;
    setDeleteModal( true );
  }, [] );

  const formatInvitationType = ( type:string ) => {
    if ( type === 'OPORTUNIDAD_PERSONAL' ) {
      return (
        <>
          OPORTUNIDAD
          <br />
          PERSONAL
        </>
      );
    }

    if ( type === 'OPORTUNIDAD' ) {
      return 'PLANTILLA OPORTUNIDAD';
    }

    return type;
  };

  const headers = [
    {

      headerClassName: 'text--left',
      accessor: 'categoria',
      className: 'text--bold',
    },

    {
      Header: t( 'admin.invitations.header21' ),
      headerClassName: 'text--left',
      accessor: 'type',
      Cell: ( { cell }: CellProps<any> ) => (
        <span className="text--bold">
          {formatInvitationType( cell.value )}
        </span>
      ),
    },
    {
      Header: t( 'admin.invitations.header2' ),
      headerClassName: 'text--left',
      accessor: 'email',
      customWidth: 300,
      Cell: ( { cell, row }: CellProps<any> ) => {
        if ( row.original.type === 'OPORTUNIDAD' ) {
          return row.original.codigoOportunidad;
        }
        return cell.value;
      },
    },
    {
      Header: t( 'admin.invitations.header4' ),
      headerClassName: 'text--left',
      accessor: 'ndaEstado',
      customWidth: 150,
      Cell: ( { cell, row }: CellProps<any> ) => {
        if ( row.original.type === 'OPORTUNIDAD' ) {
          return '-';
        }
        return <span className="text--bold">{getNdaStatusName( cell.value, !!row.original.ndaEnvelopeId )}</span>;
      },
    },
    // {
    //   Header: t( 'admin.invitations.header41' ),
    //   headerClassName: 'text--left',
    //   accessor: 'estadoInvitacion',
    //   customWidth: 150,
    //   Cell: ( { cell, row }: CellProps<any> ) => {
    //     if ( row.original.type === 'OPORTUNIDAD' ) {
    //       return '-';
    //     }
    //     return <span className="text--bold">{getInvitationStatusName( cell.value )}</span>;
    //   },
    // },
    {
      Header: t( 'admin.invitations.header6' ),
      headerClassName: 'text--left',
      accessor: 'carpetasPaths',
      Cell: ( { cell }: CellProps<any> ) => {
        let carpetasArray: string[] = [];

        if ( typeof cell.value === 'string' ) {
          try {
            const parsed = JSON.parse( cell.value );
            if ( Array.isArray( parsed ) ) {
              carpetasArray = parsed;
            }
          } catch ( e ) {
            carpetasArray = [];
          }
        } else if ( Array.isArray( cell.value ) ) {
          carpetasArray = cell.value;
        }

        const cantidad = carpetasArray.length;

        return (
          <span className="text--bold d-block text-truncate" style={{ maxWidth: '350px' }}>
            {cantidad}
          </span>
        );
      },
    },
    {
      Header: t( 'admin.invitations.header5' ),
      headerClassName: 'text--left',
      accessor: 'lastAccessAt',
      customWidth: 150,
      Cell: ( { cell }: CellProps<any> ) => (
        <>
          {cell.value ? ( <span className="text--bold">{moment( cell.value ).format( 'DD-MM-YYYY' )}</span> ) : null}
          <br />
          {cell.value ? ( <span className="text--bold">{moment( cell.value ).format( 'HH:mm:ss' )}</span> ) : null}
        </>
      ),
    },
    {
      Header: t( 'admin.invitations.header51' ),
      headerClassName: 'text--left',
      accessor: 'fechaExpiracionEnlace',
      customWidth: 150,
      Cell: ( { cell }: CellProps<any> ) => (
        <>
          {cell.value ? ( <span className="text--bold">{moment( cell.value ).format( 'DD-MM-YYYY' )}</span> ) : null}
          <br />
          {cell.value ? ( <span className="text--bold">{moment( cell.value ).format( 'HH:mm:ss' )}</span> ) : null}
        </>
      ),
    },
    {
      Header: t( 'admin.invitations.header7' ),
      accessor: 'item5',
      className: 'text--right',
      disableSortBy: true,
      customWidth: 150,
      Cell: ( { cell }: CellProps<any> ) => {
        const isCopied = copiedId === cell.row.original.id;

        const handleCopy = () => {
          const { original } = cell.row;
          let urlPath = '';

          if ( original?.categoria === 'ENLACE' ) {
            if ( original?.linkUuid ) {
              urlPath = `/link/validando-invitacion/${original.linkUuid}`;
            }
          } else {
            urlPath = `/link/informacion-confidencial/${original?.invitacionUid}`;
          }

          if ( !urlPath ) {
            return;
          }

          const url = `${window.location.origin}${urlPath}`;
          copyClipboard( url, () => {
            setCopiedId( original.id );

            setTimeout( () => {
              setCopiedId( null );
            }, 2000 );
          } );
        };

        return (
          <>
            {cell.row.original.type !== 'OPORTUNIDAD' && (
            <Button
              className="p-0"
              variant="link"
              onClick={handleCopy}
              title={isCopied ? 'Copied!' : 'Copy link'}
            >
              {isCopied ? (
                <FaRegCheckCircle className="me-2" />
              ) : (
                <FaRegCopy className="me-2" />
              )}
            </Button>
            )}
            <Button
              className="p-0"
              variant="link"
              title="Clone Invitation"
              onClick={() => {
                openCloneInvitationModal( cell.row.original );
              }}
            >
              <FaRegClone className="me-1" />
            </Button>
            <Button
              className="p-0"
              variant="link"
              onClick={() => {
                openEditInvitationModal( cell.row.original );
              }}
            >
              <i className="icon-eye-line text-primary icon--xs" />
            </Button>
            <Button
              className="p-0"
              variant="link"
              onClick={() => {
                openDeleteModal( cell.row.original );
              }}
            >
              <AiOutlineDelete />
            </Button>
          </>
        );
      },
    },
  ];

  const defaultSortBy = [{ id: 'firstName', desc: true }];

  return (
    <>
      <Table
        columns={[...headers]}
        isLoading={isLoading}
        data={invitations.data}
        total={invitations.totalItems}
        pageCount={invitations.pageCount}
        fetchData={fetchData}
        defaultSortBy={defaultSortBy}
        header={( filters, setFilters ) => (
          <Row className="align-items-center">
            <Col lg={9} sm={8} xs={6}>
              <Button
                size="sm"
                className="pt-2 pb-2 ps-4 pe-4 text--normal btn--rounded d-flex align-items-center"
                onClick={() => { openCreateInvitationModal( ); }}
              >
                <IoIosAddCircleOutline size={24} className="me-2" />
                {t( 'admin.common.createInvitations' )}
              </Button>
            </Col>
            <Col lg={3} sm={4} xs={6}>
              <TextField
                value={criteria}
                showErrors={false}
                placeholder="search"
                appendIcon="icon-search text-primary"
                onChange={( value ) => {
                  setCriteria( value );
                  debounceSearch( () => setFilters( ['email', 'ndaEstado'], value ) );
                }}
                classNames={{ formGroup: 'input-filters' }}
              />
            </Col>
          </Row>
        )}
      />
      {showDeleteModal && selectedInvitationRef.current?.id && (
      <DeleteInvitationModal
        invitationId={selectedInvitationRef.current?.id}
        onClose={closeDeleteModal}
        reloadData={reloadData}
      />
      )}
    </>

  );
}

export default Invitations;
